import { computed } from "vue";
import { useCustomerStore } from "@/stores/customer";

export function useHpPartnerLogic() {

  const customerStore = useCustomerStore()

  const hpDNIS = ['8082073795','8082073796']
  const hpTicketToAddress = 'hpsupport@iolo.com'
  const hpCustomerNotice = 'HP CUSTOMER'
  const hpSkuLabel = ' (HP)'

  // Also has customer button for subscriptions list, for HP customers

  const hpZendeskMacros = {
    hp_activate: 'Installation and Activation',
    hp_adding_protection_to_other_pcs: 'Adding protection to other PCs',
    hp_receiving_an_error_message: 'Receiving an error message',
    hp_changing_scheduled_maintenance: 'Changing scheduled maintenance',
    hp_system_performance_slow_after_running_system: 'System performance slow after running system',
    hp_others: 'Others'
  }

  // Sourced from customerStore.partnerFlags.hp, resolved once per profile load in
  // customerSupport.js from the admin-configurable partner_no_upsell_hp callout
  // (agent_ui.cash_callout_configs, edited via AdminCalloutsView.vue's condition builder) — see
  // customerSupport.js's resolveSubscriptionMatchKeys. Falls back to the raw SKU pattern only when
  // that callout has never had trigger_conditions configured (customerStore.partnerFlags.hp absent).
  const isHpSubscription = (sub) => {
    const hp = customerStore.getPartnerFlags?.hp
    if (!hp) return sub?.sku?.endsWith('_HP') || sub?.sku?.startsWith('HP_')
    return !!sub?.subscription_dim_key && hp.subscriptionKeys.includes(sub.subscription_dim_key)
  }

  // Same fired/kill-switch result that drives the partner_no_upsell_hp banner (customerSupport.js's
  // resolveTrigger) — exposed here so every other HP-gated consumer (sales.js's product/bundle
  // catalog swap, etc.) shares that one source of truth instead of recomputing its own DNIS/ticket/
  // SKU check.
  const isHpCustomer = computed(() => customerStore.getPartnerFlags?.hp?.isCustomer ? 'HP' : false)

  return { isHpCustomer, hpZendeskMacros, hpDNIS, hpTicketToAddress, isHpSubscription, hpCustomerNotice, hpSkuLabel }
}
